import React,{ Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { signIn } from '../actions'


class Registro extends Component{
  
  constructor(props) {
    super(props);
    this.state = {
      nombre:"",
      apellido:"",
      correo:"",
      recorreo:"",
      pass:"",
      repass:"",
      msj:""
    }
    this.cambia = this.cambia.bind(this)
  	}

	cambia = (key,value)=>{
		this.setState({[key]:value})
	}

	enviaRegistro = (e) => {
    if(this.state.apellido==""){
      this.setState({msj:"DEBE COMPLETAR SU APELLIDO"})
    }else if(this.state.nombre==""){
      this.setState({msj:"DEBE COMPLETAR SU NOMBRE"})
    }else if(this.state.correo==""){
      this.setState({msj:"DEBE COMPLETAR SU EMAIL"})
    }else if(this.state.correo!=this.state.recorreo){
      this.setState({msj:"LAS DIRECCIONES DE MAIL NO COINCIDEN"})
    }else if(this.state.pass==""){
      this.setState({msj:"DEBE COMPLETAR SU PASSWORD"})
    }else if(this.state.pass!=this.state.repass){
      this.setState({msj:"LOS PASSWORDS NO COINCIDEN"})
    }else{
      var d ={
        user:this.state.correo,
        pass:this.state.pass,
        nombre:this.state.nombre,
        apellido:this.state.apellido
      }
      this.props.signIn(d)
    }
	}

  componentDidMount(){
    if(this.props.usuario.user){
      this.props.history.push("/usuario")
    }
  }

	componentDidUpdate(prevProps, prevState){
		if(this.props.usuario.user){
      this.props.history.push("/usuario")
    }
	}

	render(){
		return (
			 <div className="container">
        <h1 className="display-4">REGISTRATE</h1>
        { this.state.msj!="" &&
        <div className="alert alert-danger" role="alert">
          { this.state.msj }
        </div>
        }
        <form>
          <div className="form-row">
            <div className="col-md-4 mb-3">
              <label >Nombre</label>
              <input type="text" className="form-control" id="nombre"  placeholder="Ingrese su Nombre" onChange={evt => this.cambia('nombre',evt.target.value)}/>
            </div>
            <div className="col-md-4 mb-3">
              <label >Apellido</label>
              <input type="text" className="form-control" id="apellido" placeholder="Ingrese su Apellido" onChange={evt => this.cambia('apellido',evt.target.value)}/>
            </div>
          </div>

          <div className="form-row">
            <div className="col-md-4 mb-3">
              <label >E-Mail</label>
              <input type="email" className="form-control" id="correo" aria-describedby="emailHelp" placeholder="Ingrese su Email" onChange={evt => this.cambia('correo',evt.target.value)}/>
              <small id="emailHelp" className="form-text text-muted">Este sera su usuario.</small>
            </div>
            <div className="col-md-4 mb-3">
              <label >Reingrese el E-Mail</label>
              <input type="email" className="form-control" id="recorreo" aria-describedby="emailHelp" placeholder="Reingrese su Email" onChange={evt => this.cambia('recorreo',evt.target.value)}/>
            </div>
          </div>

          <div className="form-row">
            <div className="col-md-4 mb-3">
              <label >Password</label>
              <input type="password" className="form-control" id="pass"  onChange={evt => this.cambia('pass',evt.target.value)}/>
            </div>
            <div className="col-md-4 mb-3">
              <label >Reingrese el Password</label>
              <input type="password" className="form-control" id="repass"  onChange={evt => this.cambia('repass',evt.target.value)} />
            </div>
          </div>
          <div className="form-group form-check">
            <input type="checkbox" className="form-check-input" id="exampleCheck1"/>
            <label className="form-check-label" >Desea recibir novedades por email?</label>
          </div>
			 	 <button type="button" className="btn btn-info m-2" onClick={this.enviaRegistro}>CONTINUAR</button>
          <button type="button" className="btn btn-info m-2" onClick={(e)=>this.props.history.push("/login")}>LOGUEARME</button>
        </form>
			</div>
		)
	}

};

const mapStateToProps = (state, ownProps) => {
  return {
      usuario: state.usuario
    }
}

const mapDispatchToProps = dispatch => {
  return {
    signIn: (d) => {
      dispatch(signIn(d))
    }
  }
}
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps)(Registro))



// WEBPACK FOOTER //
// ./src/containers/registro.js